/**
 * @fileoverview GET handler for the "/generative_ai/agents/unique_name" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentsUniqueName } from "./constants";
import type { GenerativeAiAgentsUniqueNameResult } from "./types";
import { isGenerativeAiAgentsUniqueNameResult } from "./validators";

export const getGenerativeAiAgentsUniqueName = reactQueryFetcherAdapter(
  generativeAiAgentsUniqueName,
  (signal: AbortSignal, appGroupId: string, proposedName: string): Promise<GenerativeAiAgentsUniqueNameResult> => {
    return fetch(
      generativeAiAgentsUniqueName,
      "GET",
      { app_group_id: appGroupId, proposed_name: proposedName },
      { signal }
    );
  },
  isGenerativeAiAgentsUniqueNameResult
);
